import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { totalOrder, totalSales } from 'data/dashboard/default';
import TotalOrder from './TotalOrder';
import TotalSales from './TotalSales';

const Dashboard = () => {
  return (
    <>
      <Row className="g-3 mb-3">
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} titleCard="Deuda" />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} titleCard="Tickets" />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} titleCard="Consumo" />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} titleCard="Estado" />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6}>
          <TotalSales data={totalSales} />
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
